import { Capacitor } from "@capacitor/core";
import { pickCampaign, resolveAdPlatform, resolveClickUrl } from "@yjsgames/house-ads";
import { HOUSE_AD_CAMPAIGNS, houseAdAssetUrl } from "../ads/houseAdData.js";
import type { AdFormat } from "@yjsgames/ad-ports";
import { diag } from "../app/diag.js";
import type { GameBoot } from "./BootTypes.js";

const log = diag("settings");

/** 광고 미리보기 (치트) — dev 모달을 닫고 즉시 표시. reward=보상형(라우팅), interstitial=자사 전면(보상 없음). */
export function previewHouseAd(boot: GameBoot, format: AdFormat): void {
  const { modals } = boot;
  modals.closeCheat();
  modals.closeDebugDashboard();
  log.diag("previewHouseAd", format);
  if (format === "reward") {
    boot.rewardedAd().showRewarded({ onReward: () => {}, onSkip: () => {} });
    return;
  }
  const campaign = pickCampaign(Math.random, HOUSE_AD_CAMPAIGNS);
  if (!campaign) return;
  modals.openHouseAd({
    campaign,
    mediaUrl: houseAdAssetUrl(campaign),
    format: "interstitial",
    onClose: () => modals.closeHouseAd(),
    onCtaClick: () => {
      const url = resolveClickUrl(
        campaign,
        resolveAdPlatform(Capacitor.getPlatform(), navigator.userAgent),
      );
      if (typeof window !== "undefined") window.open(url, "_blank", "noopener");
    },
  });
}
